import { V1Pod } from '@kubernetes/client-node';
import { produce } from 'immer';
import { create } from 'zustand';
import { combine } from 'zustand/middleware';
import { DescribePodData } from 'api/deployment/routes/deploymentDescribePodRoute';

export type PodInfoState = {
  data: DescribePodData | { status: 'empty' };
  dialog: {
    open: boolean;
    fullscreen: boolean;
  };
};

const initialState: PodInfoState = {
  data: { status: 'empty' } as const,
  dialog: {
    open: false,
    fullscreen: false,
  },
};

/** Hold state for active log and log dialog
 *  NOTE! In general don't use this directly, use useLog instead
 */
export const usePodInfoState = create(
  combine(initialState, (set, get) => ({
    showDialog: (data: DescribePodData) =>
      set(
        produce((state: PodInfoState) => {
          state.dialog.open = true;
          state.dialog.fullscreen = false;
          state.data = data;
        })
      ),

    hideDialog: () =>
      set(
        produce((state: PodInfoState) => {
          state.dialog.open = false;
        })
      ),

    toggleFullscreen: () =>
      set(
        produce((state: PodInfoState) => {
          state.dialog.fullscreen = !state.dialog.fullscreen;
        })
      ),
  }))
);
